import { render, staticRenderFns } from "./BirthdaysBookings.vue?vue&type=template&id=3f0413c6&scoped=true&"
import script from "./BirthdaysBookings.vue?vue&type=script&lang=ts&"
export * from "./BirthdaysBookings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0413c6",
  null
  
)

export default component.exports